import gql from 'graphql-tag';

export default gql`
  query {
    courses(sort: INDEX_ASC) {
      _id
      name
      description
      photo
      index
      status
      alive_course
      courseItems {
        _id
        index
        subject {
          _id
          name
          description
          photo
          status
          alive_subject
          teacher {
            _id
            firstname
            lastname
            avatar
          }
        }
      }
    }
  }
`;
